import { LogEntriesAccordianItemCombinedProps } from './types';

const usePresenter = (props: LogEntriesAccordianItemCombinedProps): LogEntriesAccordianItemCombinedProps => {
  return props;
};

export default usePresenter;
